import * as types from './action-types';

export const launchApp = () => {
  return {
    type: types.APP_LAUNCHED
  };
};

export const quitApp = (error = '', logs = '') => {
  return {
    type: types.APP_QUIT
  };
};



// WEBPACK FOOTER //
// ./src/actions/launch-actions.js